import React from "react";
import { Colors } from "../../config/Constants";
import styled from "styled-components";

interface Props {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: (e: any) => void;
  urls: any;
  name: string;
}

const BenefitsPDF = ({ onChange, urls, name, onRemove }: Props) => {
  return (
    <FieldWrapper>
      <Label>{`Upload Benefits PDF (If available in PDF format).`}</Label>
      <Input
        type="file"
        style={{ display: "none" }}
        id="pdfFile"
        accept=".pdf"
        onChange={onChange}
        name={name}
      />
      <DataWrapper>
        {}
        {urls.length > 0 ? (
          <>
            {urls.map((eachUrl: any) => (
              <FileName hasFile={true}>{eachUrl.originalname}</FileName>
            ))}
            <IconContainerSpan onClick={onRemove}>
              <SideIcon src={require("../../assets/images/close.png")} />
            </IconContainerSpan>
          </>
        ) : (
          <>
            <FileName hasFile={false}>Upload PDF</FileName>
            <IconContainerLabel htmlFor="pdfFile" disabled={urls.length === 1}>
              <SideIcon src={require("../../assets/images/upload.png")} />
            </IconContainerLabel>
          </>
        )}
      </DataWrapper>
      <Helper>{`Only PDF file with max size of 2MB.`}</Helper>
    </FieldWrapper>
  );
};

interface StyledInputProps {
  hasFile: boolean;
}

interface StyledLabelProps {
  disabled?: boolean;
}

const FileName = styled.div<StyledInputProps>`
  font-size: 13px;
  color: ${(props) => (props.hasFile ? Colors.black : Colors.athensGray)};
`;
const FieldWrapper = styled.div`
  padding-top: 1.5rem;
`;

const DataWrapper = styled.div`
  fontsize: 13px;
  border-radius: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0.5rem;
  border: 1px solid ${Colors.athensGray};
`;

const SideIcon = styled.img`
  width: 1rem;
`;

const Input = styled.input`
  display: none;
`;

const IconContainerLabel = styled.label<StyledLabelProps>`
  display: flex;
  justifycontent: center;
  alignitems: center;
`;

const IconContainerSpan = styled.span<StyledLabelProps>`
  display: flex;
  justifycontent: center;
  alignitems: center;
`;

const Label = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
`;

const Helper = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 11px;
  line-height: 16px;
  color: ${Colors.logan};
  margin-top: 0.5rem;
`;

export default BenefitsPDF;
